import { AfterViewInit, Directive, ElementRef, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';

@Directive({
    selector: '[tooltipIfTruncated]',
    hostDirectives: [
        {
            directive: MatTooltip,
            inputs: ['matTooltipShowDelay: tooltipIfTruncatedShowDelay'],
        },
    ],
})
export class TooltipIfTruncatedDirective implements AfterViewInit, OnChanges, OnDestroy {
    @Input('tooltipIfTruncated') tooltipText?: string | null;

    @Input() tooltipIfTruncatedShowDelay = 500;

    private resizeObserver?: ResizeObserver;

    constructor(
        private readonly elementRef: ElementRef<HTMLElement>,
        private readonly matTooltip: MatTooltip
    ) {}

    ngAfterViewInit(): void {
        this.scheduleUpdate();

        if (typeof ResizeObserver !== 'undefined') {
            this.resizeObserver = new ResizeObserver(() => this.scheduleUpdate());
            this.resizeObserver.observe(this.elementRef.nativeElement);
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['tooltipIfTruncated'] || changes.tooltipIfTruncatedShowDelay) {
            this.scheduleUpdate();
        }
    }

    ngOnDestroy(): void {
        this.resizeObserver?.disconnect();
    }

    private scheduleUpdate(): void {
        requestAnimationFrame(() => {
            requestAnimationFrame(() => this.updateTooltip());
        });
    }

    private updateTooltip(): void {
        const element = this.elementRef.nativeElement;
        const message = this.tooltipText?.trim() || element.textContent?.trim() || '';

        this.matTooltip.message = message;
        this.matTooltip.disabled = !message || !this.isTruncated(element);
    }

    private isTruncated(element: HTMLElement): boolean {
        return this.elementOverflows(element);
    }

    private elementOverflows(element: HTMLElement): boolean {
        return element.scrollWidth > element.clientWidth || element.scrollHeight > element.clientHeight;
    }
}
